Object.defineProperty(exports, '__esModule', { value: true });

const tracing = require('@sentry-internal/tracing');



exports.Apollo = tracing.Apollo;
exports.Express = tracing.Express;
exports.GraphQL = tracing.GraphQL;
exports.Mongo = tracing.Mongo;
exports.Mysql = tracing.Mysql;
exports.Postgres = tracing.Postgres;
exports.Prisma = tracing.Prisma;
//# sourceMappingURL=integrations.js.map
